@if (label) {
  <div class="mb-2">
    <span class="font-semibold">{{ label }}</span>
  </div>
}
<form [formGroup]="searchForm">
  <div class="flex gap-4 items-center">
    <div class="flex gap-4 items-center">
      <label class="label font-semibold">
        @if (!isDefaultViewMode) {
          <span class="label is-required">*</span>
        }
        NPI: </label>
      <p-input-mask
        slotChar=""
        mask="999999999999"
        [maxlength]="12"
        formControlName="searchText"
        placeholder="Enter the NPI"
        [autoClear]="false"
      ></p-input-mask>
    </div>
    <button
      pButton
      type="submit"
      label=" Search"
      icon="pi pi-search"
      [loading]="isLoading"
      [disabled]="!searchForm.valid"
      (click)="searchNPI()"
    ></button>
    @if (displayFollowingCheckbox && !isDefaultViewMode) {
      <div class="flex gap-4 items-center ml-4">
        <label class="label font-semibold">Same as Ordering Provider:</label>
        <p-checkbox
          name="actionTaken"
          binary="true"
          [formControl]="sameAsOrderingCheck"
        ></p-checkbox>
      </div>
    }
  </div>
  @if (isPhysicianNotFoundView || npiNotFound) {
    <div class="pt-1">
      <div class="mb-4">
        <span class="physician-not-found">{{ physicianType }} Provider Not found.</span>
      </div>
      @if (!isDefaultViewMode) {
        <div class="flex items-center">
          <p-checkbox
            inputId="npiNotFoundCheck"
            binary="true"
            [formControl]="npiCheck"
          ></p-checkbox>
          <label for="npiNotFoundCheck" class="ml-2">NPI was not found. Click this checkbox and add new provider
            information below to continue</label>
        </div>
      }
    </div>
  }
</form>
